import { AxiosResponse } from 'axios';
import { useOmnichannelStore } from '../store/ModuloOmnichannel.store';
import * as service from '../services';
import { useMutation } from '@tanstack/react-query';
import { useNotification } from '../../../../../hooks';
import { DetailsRequest, DetailsResponse } from '../types';

export const useGetOmnichannelDetails = () => {
  const { setOmnichannelState } = useOmnichannelStore();
  const { handleNotification } = useNotification();

  const getOmnichannelDetailsRequest = async (data: DetailsRequest) => {
    const resp = await service.getOmnichannelDetails(data);
    return resp;
  };

  const successAction = (data: AxiosResponse<DetailsResponse>) => {
    setOmnichannelState('omnichannelDetailsData', data?.data);
    if (Array.isArray(data?.data) && data.data.length === 0) {
      handleNotification(
        'info',
        'Nenhum resultado encontrado para os filtros selecionados. Ajuste produtos, redes, localização ou período e tente novamente.',
      );
    }
  };

  const mutate = useMutation({
    mutationFn: getOmnichannelDetailsRequest,
    onSuccess: data => successAction(data),
    onError: (error: { response?: unknown }) => {
      if (!error?.response) {
        handleNotification('error', 'Erro ao buscar detalhamento. Verifique sua conexão.');
      }
    },
  });

  const handleDetailsPageChange = (page: number, size: number) => {
    const requestBody = useOmnichannelStore.getState().omnichannelRequestBody;
    const bodyRequest = { ...requestBody, page: page - 1, size: size || 10 };
    setOmnichannelState('omnichannelRequestBody', bodyRequest);
    mutate.mutate(bodyRequest);
  };

  return { handleDetailsPageChange, isLoadingOmnichannelDetails: mutate.isPending };
};
